var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 51,
    viewBox: "0 0 105 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4998 43C62.0723 43 69.8332 35.1648 69.8332 25.5C69.8332 15.8352 62.0728 8 52.4998 8C42.9269 8 35.1665 15.8352 35.1665 25.5C35.1665 35.1648 42.9269 43 52.4998 43Z",
    fill: "#A70B52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8344 32.8085H52.6197V18.2075H51.0566V34.2492H52.6197V34.2397H56.8344V32.8085Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6221 26.058H56.7241V24.7201H66.9254C66.939 24.9788 66.9455 25.2379 66.9455 25.5001C66.9455 33.5545 60.4784 40.0834 52.5011 40.0834C44.5238 40.0834 38.0566 33.5545 38.0566 25.5001C38.0566 17.4457 44.5238 10.9167 52.5015 10.9167C52.7118 10.9167 52.9217 10.9212 53.1302 10.9304L53.1285 12.2582C52.9196 12.2485 52.7106 12.2436 52.5015 12.2436C45.25 12.2436 39.3709 18.1788 39.3709 25.5001C39.3709 32.8218 45.2496 38.7565 52.5015 38.7565C59.5554 38.7565 65.3099 33.1409 65.6186 26.0955L65.6221 26.058V26.058Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.443 22.5825C48.0177 22.5825 48.5688 22.3521 48.9751 21.9418C49.3814 21.5316 49.6097 20.9752 49.6097 20.395C49.6097 19.8149 49.3814 19.2585 48.9751 18.8482C48.5688 18.438 48.0177 18.2075 47.443 18.2075C46.8684 18.2075 46.3173 18.438 45.911 18.8482C45.5046 19.2585 45.2764 19.8149 45.2764 20.395C45.2764 20.9752 45.5046 21.5316 45.911 21.9418C46.3173 22.3521 46.8684 22.5825 47.443 22.5825V22.5825Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLgLogo);
export default __webpack_public_path__ + "static/media/icon-lg-logo.e92043d5c2aad28db239fe3943bf6990.svg";
export { ForwardRef as ReactComponent };